<template>
  <div class="chart-container">
    <div class="chart-header">
      <head-title class="head-title">
        Charts
      </head-title>
      <div class="chart-type-switcher-wrap"></div>
      <select-box
        class="range-selector chart-selectbox"
        v-model="selectedRange"
        :options="availableDateRanges"
        selectFirstByDefault
        selectId="rangeField"
      />
      <chart-type-switcher v-model="chartTypeIsMarketcap" />
      <router-link class="create-alert create-alert_desktop" :to="`/add-alert/${selectedCurrency.id}`">
        <button-el red class="assigned-alerts__create-alert">
          CREATE ALERT
        </button-el>
      </router-link>
    </div>
    <spinner-el v-if="chartUpdating" class="spinner" />
    <chart-el
      class="chart-el"
      v-else
      :chartData1="chartData1"
      :chartData2="chartData2"
      :chartType="chartType.name"
    />
    <router-link class="create-alert create-alert_mobile" :to="`/add-alert/${selectedCurrency.id}`">
      <button-el red class="assigned-alerts__create-alert">
        CREATE ALERT
      </button-el>
    </router-link>
  </div>
</template>

<script>
import ChartEl from './ChartEl';
import ChartTypeSwitcher from './ChartTypeSwitcher';

export default {
  data: () => ({
    selectedRange: null,
    chartTypeIsMarketcap: false,
    chartData1: null,
    chartData2: null,
    chartUpdating: true,
  }),
  props: {
    selectedCurrency: {
      type: Object,
      required: true,
    },
    availableDateRanges: {
      type: Array,
      required: true,
    },
  },
  components: {
    ChartEl,
    ChartTypeSwitcher,
  },
  computed: {
    chartType() {
      if (this.chartTypeIsMarketcap) {
        return {
          value: 'marketcap',
          name: 'Market Cap',
        };
      }
      return {
        value: 'price',
        name: 'Price',
      };
    },
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      this.chartUpdating = true;
      const chartOptions = {
        range: this.selectedRange.name,
        tickerId: this.selectedCurrency.id,
        chartType: this.chartType.value,
      };
      this.$apiService.getChartBigData(chartOptions).then(({ value, volume }) => {
        this.chartData1 = value;
        this.chartData2 = volume;
      }).finally(() => {
        this.chartUpdating = false;
      });
    },
  },
  watch: {
    selectedCurrency() {
      this.selectedRange = this.availableDateRanges[0];
      this.updateChart();
    },
    selectedRange() {
      this.updateChart();
    },
    chartType() {
      this.updateChart();
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.chart-container {
  background: $white-color2;
  padding: 39px 30px 8px;
  margin-bottom: 48px;
  min-height: 530px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}
.range-selector {
  margin: 0px 30px 0 32px;
  width: 180px;
}
.spinner {
  margin: auto;
}
.create-alert {
  margin-left: 30px;
  width: 150px;
  &_mobile {
    display: none;
  }
}
.chart-el {
  width: calc(100% + 39px); // remove unused padding right
}
.chart-type-switcher-wrap {
  width: 0;
}


@media screen and (max-width: 816px) {
  .create-alert {
    margin: -13px auto 32px;
    z-index: 1;
    &_desktop {
      display: none;
    }
    &_mobile {
      display: block;
    }
  }
}

@media screen and (max-width: 600px) {
  @mixin hideChartLabels() {
    .chart-el {
      width: calc(100% + 133px);
      margin-left: -15px;
    }
    .chart-container {
      overflow-x: hidden;
    }
  }
  @include hideChartLabels;
}
@media screen and (max-width: 549px) {
  .chart-header {
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .head-title {
    margin-bottom: 30px;
  }
  .chart-selectbox {
    margin-left: 0;
  }
  .chart-type-switcher-wrap {
    width: 100%;
  }
}
@media screen and (max-width: 436px) {
  .chart-header {
    flex-direction: column;
  }
  .chart-type-switcher {
    margin: 40px auto 11px;
  }
  .chart-selectbox {
    margin-right: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/currency/chartBlock/index.vue